
import './pl_landlord.css';
import StaffMockHost from './staff-mock-host.vue';
import PickLandlord from '../owner/widgets/pick-landlord.vue';

function emptyFacility() {
  return {
    ownerName: '',
    name: '',
    nameEn: '',
    doorType: '',
    lockType: '',
    managePassword: '',
    stPassword: '',
    address: '',
    frontendUrl: '',
    stayType: '',
    group: ''
  };
}

export default {
  name: 'pl-landlord-facility',
  components: {
    StaffMockHost: StaffMockHost,
    PickLandlord: PickLandlord
  },
  data: function () {
    return {
      facility: emptyFacility(),
      roomId: null,
      currentLandlordId: null,
      history: [],
      historyReady: false,
      contractStart: '',
      contractEnd: '',
      contractBusy: false,
      ui: {
        pick: false
      }
    };
  },
  watch: {
    '$route.query.room_id': function () {
      this.loadFacility();
    }
  },
  created: function () {
    var q = (this.$route && this.$route.query) || {};
    var query = {};
    if (q.room_id) query.room_id = q.room_id;
    // 旧入口只负责兼容跳转，设施编辑统一使用现有房间编辑页。
    this.$router.replace({ path: '/rooms', query: query });
  },
  methods: {
    toast: function (msg) {
      if (window.A && A.toast) A.toast(msg);
    },
    toastFail: function (status) {
      if (status == -5) this.toast('未ログイン');
      else if (status == -6) this.toast('権限がありません');
      else this.toast('取得に失敗しました');
    },
    openPick: function () {
      if (!this.roomId) return;
      this.ui.pick = true;
    },
    loadFacility: function () {
      var qid = this.$route.query.room_id;
      this.currentLandlordId = null;
      this.facility = emptyFacility();
      this.history = [];
      this.historyReady = false;
      this.contractStart = '';
      this.contractEnd = '';
      if (!qid) {
        this.roomId = null;
        return;
      }
      this.roomId = Number(qid);
      this.loadHistory();
      var t = this;
      axios.get('room/' + qid, { params: { _with: 'landlord' } }).then(function (res) {
        if (res.data.status != 1) {
          t.toastFail(res.data.status);
          return;
        }
        var room = res.data.options && res.data.options.item;
        if (!room) {
          t.toastFail(0);
          return;
        }
        t.applyRoom(room);
        t.fillOwner(room);
      }).catch(function () {
        t.toast('通信に失敗しました');
      });
    },
    applyRoom: function (room) {
      var doorType = '';
      if (room.lock_type == 1) doorType = '開き';
      else if (room.lock_type == 2) doorType = '引き';
      var lockType = '';
      if (room.smart_lock == 0) lockType = 'アナログ';
      else if (room.smart_lock == 1) lockType = '電子錠';
      this.facility = {
        ownerName: '',
        name: room.name || '',
        nameEn: room.name_en || '',
        doorType: doorType,
        lockType: lockType,
        managePassword: room.admin_password || room.static_password || '',
        stPassword: room.case_password || '',
        address: room.address || '',
        frontendUrl: room.google_map_url || room.frontend || '',
        stayType: room.type || '',
        group: ''
      };
    },
    fillOwner: function (room) {
      var t = this;
      if (!room.landlord_id) {
        t.currentLandlordId = null;
        t.facility.ownerName = '所有者なし';
        return;
      }
      t.currentLandlordId = room.landlord_id;
      var related = room.landlord;
      if (related && (related.name || related.lastname || related.firstname)) {
        t.facility.ownerName = related.name || ((related.lastname || '') + (related.firstname || ''));
        return;
      }
      axios.get('landlord/' + room.landlord_id).then(function (res) {
        if (res.data.status != 1) return;
        var item = res.data.options && res.data.options.item;
        if (!item) return;
        t.facility.ownerName = item.name || ((item.lastname || '') + (item.firstname || ''));
      });
    },
    loadHistory: function () {
      this.history = [];
      this.historyReady = false;
      if (!this.roomId) return;
      var t = this;
      var reqRoomId = this.roomId;
      axios.get('room/landlordHistory', { params: { room_id: this.roomId } }).then(function (res) {
        if (reqRoomId !== t.roomId) return;
        if (res.data.status != 1) {
          t.toastFail(res.data.status);
          return;
        }
        t.history = (res.data.options && res.data.options.items) || [];
        t.historyReady = true;
        t.applyContract(t.history);
      }).catch(function () {
        if (reqRoomId !== t.roomId) return;
        t.toast('通信に失敗しました');
      });
    },
    applyContract: function (rows) {
      rows = rows || [];
      var open = null;
      for (var i = 0; i < rows.length; i++) {
        if (!rows[i].effective_to && rows[i].landlord_id) {
          open = rows[i];
          break;
        }
      }
      var row = open || rows[0] || null;
      this.contractStart = row && row.effective_from ? row.effective_from : '';
      this.contractEnd = row && row.contract_end ? row.contract_end : '';
    },
    saveContractEnd: function () {
      if (!this.roomId || this.contractBusy) return;
      var t = this;
      t.contractBusy = true;
      axios.post('room/setContractEnd', {
        room_id: Number(this.roomId),
        contract_end: this.contractEnd || ''
      }).then(function (res) {
        t.contractBusy = false;
        if (res.data.status != 1) {
          t.toastFail(res.data.status);
          return;
        }
        var opt = res.data.options || {};
        if (opt.history) {
          t.history = opt.history;
          t.historyReady = true;
          t.applyContract(opt.history);
        }
        if (opt.item) {
          t.applyRoom(opt.item);
          t.fillOwner(opt.item);
        } else {
          t.loadFacility();
        }
        t.toast('保存しました');
      }).catch(function () {
        t.contractBusy = false;
        t.toast('通信に失敗しました');
      });
    },
    formatHistoryRow: function (row) {
      var from = row.effective_from || '';
      var to = row.effective_to ? row.effective_to : '現在';
      var name = row.landlord_name || '所有者なし';
      return from + ' ～ ' + to + '　' + name;
    },
    onAssigned: function (payload) {
      if (payload && payload.item) {
        this.applyRoom(payload.item);
        this.fillOwner(payload.item);
        this.loadHistory();
        return;
      }
      this.loadFacility();
    }
  }
};
